import React from 'react'
import { TableRow, TableHeaderCell, TableHeader, TableBody, Table } from 'semantic-ui-react'

interface SemanticListTableProps {
  title: string
  actionSection: () => void
  children: () => void
}

export default function SemanticListTable({
  title,
  actionSection,
  children,
}: SemanticListTableProps) {
  return (
    <Table basic unstackable className="list-table">
      <TableHeader>
        <TableRow>
          <TableHeaderCell colSpan={2}>
            <div className="flex items-center justify-between">
              <div>{title}</div>
              <div>{actionSection}</div>
            </div>
          </TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>{children}</TableBody>
    </Table>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/Table/SemanticListTable/index.tsx